function TroubleShooting() {
	return (
  <div className="App">
  </div>
);
}

export default TroubleShooting;